"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

// import fetchProfileData from "./api";
//
// interface pictureObj {
//     imageSrc?: string
// }
// type scale_container = {
//     w: number,
//     h: number
// }
// const Image = (imageSrc?: string | undefined) => <img style={{width: '76px', height: '76px'}} src={imageSrc}/>
// const scaleImm = (node?: any, scale?: scale_container): object => {
//     if (!node || node && !node.current) return {}
//     // console.log(node.current);
//     // console.log(node.current.clientHeight);
//     // console.log(node.current.clientWidth);
//     let getNodeW = node.current.clientWidth;
//     let getNodeH = node.current.clientHeight;
//     const {w, h} = scale || {};
//     if (w && h) {
//         if (getNodeW < w && getNodeH > h) {
//             getNodeW = getNodeW - (getNodeH - w) / getNodeH * getNodeW;
//             getNodeH = '100%'
//             // getNodeH = w;
//         } else if (getNodeW > w && getNodeH < h) {
//             getNodeH = getNodeH - (getNodeW - w) / getNodeW * getNodeH;
//             getNodeW = w;
//         } else if (getNodeH > h && getNodeW > w) {
//             if (getNodeH > getNodeW) {
//                 getNodeW = getNodeW - (getNodeH - w) / getNodeH * getNodeW;
//                 getNodeH = w;
//             } else {
//                 getNodeH = getNodeH - (getNodeW - w) / getNodeW * getNodeH;
//                 // getNodeW = w;
//                 getNodeW = '100%'
//             }
//         } else {
//         }
//     }
//     // node.current.style.width = getNodeW;
//     // node.current.style.height = getNodeH;
//     // console.log(getNodeW, getNodeH, scale);
//     // console.log('origin', node.current.clientWidth);
//     // console.log('origin', node.current.clientHeight);
//     return {
//         width: getNodeW,
//         height: getNodeH
//     }
// }
function ProfileDetails(props) {
  var styles = props.styles,
      imageSrc = props.imageSrc; // const user = resource.user.read();

  var _a = (0, _utils.fomateFileData)(imageSrc),
      url = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;

  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({}, styles),
    src: url,
    alt: alt
  });
}

function PictureComponent(props) {
  var imageSrc = props.imageSrc;
  var url = (0, _utils.fomateFileData)(imageSrc).url; // fetchProfileData(imageSrc, index);

  var _a = (0, _react.useState)({}),
      styles = _a[0],
      setStyls = _a[1]; // new Promise((resolve) => {


  (0, _react.useEffect)(function () {
    var imgLoad = new Image();

    if (url) {
      imgLoad.src = url;
    }

    imgLoad.onload = function () {
      var collectStyles = {}; // console.log(imgLoad.width, '宽度《----～----》高度', imgLoad.height);

      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }

      setStyls(collectStyles); // resolve(collectStyles)
      // console.log(index, collectStyles)
    };
  }, []); // });

  return /*#__PURE__*/_react["default"].createElement(ProfileDetails, __assign({}, {
    styles: styles,
    imageSrc: imageSrc
  }));
}

var _default = PictureComponent;
exports["default"] = _default;